import { HttpErrorResponse } from '@angular/common/http';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { PaymentMethod } from '../../entities';

import * as PaymentActions from './methods.actions';

export const paymentMethodsFeatureKey = 'payment-methods';

export interface PaymentMethodsState {
    loaded: boolean;
    error: HttpErrorResponse | null;
}

export interface PaymentMethodsEntityState extends EntityState<PaymentMethod>, PaymentMethodsState {}

const initialState = {
    loaded: false,
    error: null
} as PaymentMethodsState;

export const paymentMethodsAdapter: EntityAdapter<PaymentMethod> = createEntityAdapter<PaymentMethod>();

const initialPaymentMethodsState = paymentMethodsAdapter.getInitialState(initialState);

export const paymentMethodsReducer = createReducer(
    initialPaymentMethodsState,
    on(PaymentActions.loadPaymentMethodsSuccess, (state, { paymentMethods }) =>
        paymentMethodsAdapter.setAll(paymentMethods, {
            ...state,
            loaded: true
        })
    ),
    on(PaymentActions.loadPaymentMethodsFailure, (state, { error }) => ({ ...state, error }))
);
